import { render, staticRenderFns } from "./settingsView.vue?vue&type=template&id=35bda795&scoped=true&"
import script from "./settingsView.vue?vue&type=script&lang=js&"
export * from "./settingsView.vue?vue&type=script&lang=js&"
import style0 from "./settingsView.vue?vue&type=style&index=0&id=35bda795&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bda795",
  null
  
)

component.options.__file = "settingsView.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCard,
  VCardTitle,
  VDataTable,
  VDialog,
  VFlex,
  VIcon,
})
